// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type SpeechModelListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetSpeechModelListe(): () => Promise<SpeechModelListe> {
  const getAPI = useGetApi();
  return useCallback(
    async () => (await getAPI()).speechModel.getSpeechModelListe(),
    [getAPI]
  );
}
